<template>
  <v-col :lg="getSize()" cols="12">
    <v-card
      tile
      text
      ref="chartContainer"
      v-if="widgetInfo.kpiSlug !== 'empty_slug'"
      class="d-flex flex-col dynamic-widget-card"
      :class="`shadow`"
      :data-test-id="`dashboard-monitoring-widget-card__${widgetInfo.kpiSlug}`"
    >
      <!-- <v-container> -->
      <div>
        <v-row>
          <v-col cols="10" class="px-5 widget-heading-outer">
            <v-card-title
              class="widget-heading pa-0"
              :title="widgetInfo.kpiIdName"
              >{{ getWidgetTitle(widgetInfo.kpiIdName) }}</v-card-title
            >
            <p class="dateRange mb-0" v-if="dateRangeFrom">
              {{ graphDisplayRange }}
            </p>
          </v-col>
          <v-col cols="2" class="text-end">
            <!-- <v-spacer></v-spacer> -->
            <v-btn
              icon
              small
              :ripple="false"
              :depressed="true"
              @click.stop="openAddEditWidgetDialog()"
              class="editWidgetBtn"
              data-test-id="dashboard-monitoring-widget-card__edit-btn"
            >
              <v-img
                :src="settingsImgSrc"
                aspect-ratio="1"
                class="settingImageStyle"
              ></v-img>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="!chartReady && !chartError">
        <v-col md="12" offset-md4>
          <div class="loader-el justify-center align-center">
            <img src="./../../../assets/images/loader.svg" />
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center" align="center" v-if="chartError">
        <h3 class="primarygreen--text">No Data</h3>
      </v-row>
      <p class="legend ma-0 text-md-right pr-2" v-if="chartReady">
        <span
          v-for="(legend, index) in legendArray"
          class="ml-4 legendWrapper"
          :key="index"
        >
          <span
            class="legendCircle mr-1"
            :class="{
              primaryColor: index === 0,
              secondaryColor: index === 1,
              tertiaryColor: index === 2
            }"
          ></span>
          {{ legend }}
        </span>
      </p>
      <div
        v-if="chartReady && chartType !== 'Pie'"
        :id="`columnChartContainer-${widgetId}`"
      >
        <GChart
          v-if="chartDataAvailable"
          ref="gchart"
          :type="chartType"
          :data="chartData"
          :options="chartOptions"
          :events="chartEventsForBarChart"
          @ready="chartIsReady"
          class="chart-container"
          :key="chartKey"
        />
      </div>
      <template v-if="chartReady && chartType === 'Pie'">
        <div class="canvas-parent" v-if="pieHasData">
          <canvas
            class="canvas"
            width="380"
            height="380"
            :id="`pieCanvas-${widgetInfo.id}`"
            >Sorry, canvas not supported</canvas
          >
        </div>
        <v-row
          no-gutters
          justify="center"
          align="center"
          v-if="chartReady && !pieHasData"
        >
          <h3 class="primarygreen--text">No Data</h3>
        </v-row>
      </template>
      <!-- </v-container> -->
    </v-card>
    <AddWidget height="330" :widgetInfo="widgetInfo" v-else></AddWidget>
  </v-col>
</template>

<script>
import { GChart } from 'vue-google-charts';
import AddWidget from './AddWidget';
import chartOptions from './chartOptions';
import diagJS from '@/assets/js/diag';
import colors from '@/constants/colors';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import EventBus from '@/EventBus';
export default {
  components: {
    GChart,
    AddWidget
  },
  props: ['widgetInfo', 'widgetId', 'selectedDate', 'kpiDetails'],
  data() {
    return {
      chartKey: 0,
      chartError: false,
      chartDataAvailable: false,
      chart: null,
      google: null,
      responseData: null,
      chartType: null,
      url: '',
      chartData: [],
      chartReady: false,
      chartTypeMap: {
        Line: 'LineChart',
        Bar: 'ColumnChart',
        Area: 'AreaChart',
        Pie: 'Pie'
      },
      sizeClass: {
        SMALL: '4',
        MEDIUM: '6',
        LARGE: '8'
      },
      pieHasData: false,
      chartOptionsMap: {
        Line: chartOptions.chartOptionsForLineGraph,
        Bar: chartOptions.chartOptionsForBarChart,
        Area: chartOptions.chartOptionsForAreaGraph,
        Pie: chartOptions.chartOptionsForPieChart
      },
      legendArray: [],
      dateRangeFrom: null,
      dateRangeTo: null,
      monthLength: 3,
      months: [],
      date: this.selectedDate,
      settingsImgSrc: require('@/assets/images/settings-icon.svg'),
      chartEventsForBarChart: {
        ready: () => {
          this.changeBorderRadiusForGraph();
        },
        select: () => {
          this.changeBorderRadiusForGraph();
        },
        click() {
          this.changeBorderRadiusForGraph();
        },
        onmouseover: indices => {
          this.changeBorderRadiusForGraph();

          let colLength = Object.keys(this.responseData[0]).length - 1;
          let tooltip = document.getElementsByClassName(
            'google-visualization-tooltip'
          )[0];
          let map = {
            Area: {
              default: 47,
              1: 47,
              3: 49,
              5: 46
            },
            Line: {
              default: 47,
              1: 46,
              3: 48,
              5: 46
            },
            Bar: {
              default: 44,
              1: 43,
              3: 45,
              5: 40
            }
          };
          let offset = 0;
          let targetObj = map[this.widgetInfo.widgetGraphName];
          if (colLength === 1) {
            offset = targetObj['default'];
            let map = {
              Bar: {
                LARGE: {
                  DECADE: 70,
                  YEAR: 64,
                  DAY: 44,
                  WEEK: 82
                },
                MEDIUM: {
                  DECADE: 60,
                  YEAR: 54,
                  DAY: 44,
                  WEEK: 71
                },
                SMALL: {
                  DECADE: 54,
                  YEAR: 54,
                  DAY: 44,
                  WEEK: 60
                }
              },
              Line: {
                LARGE: {
                  DECADE: 47,
                  YEAR: 48,
                  DAY: 46,
                  WEEK: 46
                },
                MEDIUM: {
                  DECADE: 49,
                  YEAR: 50,
                  DAY: 48,
                  WEEK: 49
                }
              },
              Area: {
                LARGE: {
                  DECADE: 47,
                  YEAR: 64,
                  DAY: 44,
                  WEEK: 46
                },
                MEDIUM: {
                  DECADE: 49,
                  YEAR: 50,
                  DAY: 48,
                  WEEK: 48
                }
              }
            };
            if (map[this.widgetInfo.widgetGraphName][this.widgetInfo.size]) {
              if (
                map[this.widgetInfo.widgetGraphName][this.widgetInfo.size][
                  this.widgetInfo.timeUnit
                ]
              ) {
                offset =
                  map[this.widgetInfo.widgetGraphName][this.widgetInfo.size][
                    this.widgetInfo.timeUnit
                  ];
              }
            }
          } else {
            offset = targetObj[indices.column.toString()];
            // eslint-disable-next-line
            if (indices.column === 3) {
              tooltip.classList.add('blue');
            }
            // eslint-disable-next-line
            if (indices.column === 5) {
              tooltip.classList.add('purple');
            }
          }
          tooltip.style.left =
            parseFloat(tooltip.style.left) - parseFloat(offset) + 'px';
        },
        onmouseout: () => {
          this.changeBorderRadiusForGraph();
        }
      },
      changeBorderRadiusForGraph() {
        let color = [
          colors.chartPrimary,
          colors.chartSecondary,
          colors.chartTertiary
        ];
        let container = document.getElementById(
          'columnChartContainer-' + this.widgetInfo.id
        );
        let chartColumns = container.getElementsByTagName('rect');
        Array.prototype.forEach.call(chartColumns, function(column) {
          if (
            color.indexOf(column.getAttribute('fill')) > -1 ||
            column.getAttribute('fill') === 'none'
          ) {
            const xyPadding = 8;
            const width = 15;
            column.setAttribute('rx', xyPadding);
            column.setAttribute('ry', xyPadding);
            column.setAttribute('width', width);
          }
        });
      }
    };
  },
  computed: {
    ...mapState({
      widgetUpdateHappened: state => state.dashboard.widgetUpdateHappened
    }),
    ...mapState(['isCurrentOrgLegacy']),
    graphDisplayRange() {
      return this.widgetInfo.timeUnit === 'ALL'
        ? 'All Time'
        : `${
            this.widgetInfo.timeUnit === 'DAY' ? '' : this.dateRangeFrom + '-'
          }  ${this.dateRangeTo}`;
    }
  },
  watch: {
    // eslint-disable-next-line
    selectedDate(newValue, oldValue) {
      // when date changes from calendar
      this.chartReady = false;
      this.getCardData();
    },
    // eslint-disable-next-line
    widgetUpdateHappened(newValue, oldValue) {
      let selectedWidgetInfo = this.getSelectedwidgetForEdit();
      if (!selectedWidgetInfo) {
        return false;
      }
      // this widget has been updated. data fir se mangwao. uske baad store mai currently set object ko null kar do
      if (!newValue) {
        return false;
      }
      selectedWidgetInfo = this.getSelectedwidgetForEdit();
      if (this.widgetInfo.id === selectedWidgetInfo.id) {
        // re-render graph
        this.chartReady = false;
        this.chartType = this.chartTypeMap[this.widgetInfo.widgetGraphName];
        this.getCardData();
      }
    }
  },
  methods: {
    getSize() {
      return this.sizeClass[this.widgetInfo.size];
    },
    ...mapMutations('dashboard', [
      'toggleAddEditModal',
      'setSelectedForEdit',
      'setWidgetData'
    ]),
    ...mapActions('dashboard', ['dialog']),
    ...mapGetters('dashboard', [
      'getKpiDetails',
      'getWidgetList',
      'getSelectedwidgetForEdit',
      'getWidgetData',
      'getCurrentOrgFetchedData'
    ]),
    chartIsReady(chart, google) {
      // called when we have received the data
      if (!this.google) {
        this.google = google;
      }
      let response = this.responseData;
      let allKeys = this.getSortedColumns();
      let data = new google.visualization.DataTable();
      data.addColumn('string', 'Users');

      // make time unit first column as needed in charts
      allKeys.forEach(() => {
        data.addColumn('number', null);
        data.addColumn({ type: 'number', role: 'tooltip' });
      });

      let rowDataAll = [];
      // populate data in all other rows
      response.forEach(row => {
        let rowData = [];
        rowData.push(this.formatAxisLabel(row['time_unit']));

        allKeys.forEach(keyName => {
          rowData.push(parseFloat(row[keyName])); // this is for actual bar data
          rowData.push(parseFloat(row[keyName])); // this is needed for tooltip
        });
        rowDataAll.push(rowData);
      });
      data.addRows(rowDataAll);
      this.chartData = data;
    },
    getWidgetTitle(strTitle) {
      const widgetTitleMaxLength = 40;
      if (this.widgetInfo.size === 'SMALL') {
        return strTitle.length < widgetTitleMaxLength
          ? strTitle
          : strTitle.substr(0, widgetTitleMaxLength) + '...';
      }
      return strTitle;
    },
    populateLegend() {
      let response = Object.assign(this.responseData);
      if (!response.length) {
        return;
      }
      let allKeys = this.getSortedColumns();

      let legendArr = [];
      allKeys.forEach(element => {
        legendArr.push(this.titleCase(element));
      });
      this.legendArray = legendArr;
    },
    formatAxisLabel(labelText) {
      switch (this.widgetInfo.timeUnit) {
        case 'DAY':
          return parseInt(labelText, 10) + ':00';
        case 'MONTH':
          return this.getFormattedDate({ date: labelText, format: 'DD-MMM' });
        case 'WEEK':
          return this.getFormattedDate({
            date: labelText,
            format: 'DD-MMM-YYYY'
          });
        case 'YEAR':
          return this.months[parseInt(labelText, 10) - 1];
        case 'DECADE':
          return labelText;
        case 'ALL':
          return labelText;
      }
    },
    openAddEditWidgetDialog() {
      this.setSelectedForEdit(this.widgetInfo);
      this.toggleAddEditModal(true);
    },
    async getCardData() {
      this.chartDataAvailable = false;
      this.chartError = false;
      if (this.widgetInfo.kpiSlug === 'empty_slug') {
        // this is an empty card; no need to fetch any data
        return false;
      }
      this.dateRangeFrom = '';
      this.dateRangeTo = '';

      let kpiDetails = this.getKpiDetails();
      let currentKpi = kpiDetails.find(element => {
        return element.slug === this.widgetInfo.kpiSlug;
      });

      // need to check if this is an empty card
      if (currentKpi !== undefined) {
        let paramArr = [];
        if (currentKpi.params) {
          currentKpi.params.forEach(param => {
            if (param.name === 'org_id') {
              paramArr.push({
                index: param.index,
                value: this.currentlySelectedOrgId
              });
            }
          });
          let urls = {
            email_volume: '/email/volume/v1/',
            email_total_legitimate: '/email/count/v1/'
          };
          let url =
            this.getServiceURL('baseUrlForAnalyticsService') +
            '/kpi/elastic/slug/' +
            this.currentlySelectedOrgId +
            '/' +
            this.widgetInfo.kpiSlug +
            '?tillDate=' +
            this.computeUTCTimestamp(this.selectedDate) +
            '&timeUnit=' +
            this.widgetInfo.timeUnit;
          if (
            (this.widgetInfo.kpiSlug === 'email_volume' ||
              this.widgetInfo.kpiSlug === 'email_total_legitimate') &&
            this.isCurrentOrgLegacy
          ) {
            url = `${this.getServiceURL('searchService')}${
              urls[this.widgetInfo.kpiSlug]
            }${this.currentlySelectedOrgId}`;
          }
          try {
            let response;
            if (urls[this.widgetInfo.kpiSlug]) {
              if (this.isCurrentOrgLegacy) {
                response = await this.axios.get(url);
              } else {
                response = await this.axios.post(url, {
                  validatedList: paramArr
                });
              }
              response.data.body = response?.data?.body;
            } else {
              response = await this.axios.post(url, {
                validatedList: paramArr
              });
            }
            if (response.data && response.data.body) {
              let widgetData = this.getWidgetData();
              widgetData[this.widgetInfo.id] = response.data.body;
              this.setWidgetData(widgetData);

              this.processResponse(response.data.body.reverse());
            } else {
              this.snackbar('error', this.$message.ERROR_LOADING_DATA);
            }
          } catch (err) {
            this.chartError = true;
            this.snackbar('error', err);
          }
        }
      }
    },
    updateDateRanges() {
      let dates = this.setDateRange(
        this.widgetInfo.timeUnit,
        this.selectedDate
      );
      this.dateRangeFrom = dates[0] || null;
      this.dateRangeTo = dates[1] || null;
    },
    processResponse(response) {
      this.updateDateRanges();
      this.responseData = response;
      this.chartDataAvailable = true;
      this.populateLegend(response);
      this.chartOptions = this.chartOptionsMap[this.widgetInfo.widgetGraphName];

      if (this.chartType === 'Pie') {
        this.chartReady = true;

        const formattedDataForPie = this.formatDataForPieChart(response);
        const allSum = Object.values(formattedDataForPie).reduce(function(
          acc,
          value
        ) {
          return acc + value;
        },
        0);
        if (Object.keys(formattedDataForPie).length === 0 || allSum <= 0) {
          this.pieHasData = false;
          return;
        }
        this.pieHasData = true;
        this.initPie(formattedDataForPie);
      } else {
        this.chartReady = true;
      }
    },
    getSortedColumns() {
      let kpiDetails = this.getKpiDetails();

      let currentKpi = kpiDetails.find(element => {
        return element.slug === this.widgetInfo.kpiSlug;
      });

      let currentKpiColumns = (currentKpi?.columns || []).filter(column => {
        return column.alias !== 'time_unit';
      });

      let sortedColumns = currentKpiColumns.sort((a, b) => {
        return a.order - b.order;
      });
      let allColumns = [];
      sortedColumns.forEach(column => {
        allColumns.push(column.alias);
      });

      return allColumns;
    },
    formatDataForPieChart(response, showPercentage) {
      if (!response.length) {
        return false;
      }
      let allColumns = this.getSortedColumns();
      let allSum = {};
      allColumns.forEach(key => {
        let total = response.reduce((total, item) => {
          return total + parseInt(item[key], 10);
        }, 0);
        if (key !== 'time_unit') {
          allSum[key] = total;
        }
      });

      if (!showPercentage) {
        return allSum;
      }
      let dataForPie = {};
      let sum = 0;
      for (let key in allSum) {
        if (allSum.hasOwnProperty(key)) {
          if (allSum[key] !== 0) {
            dataForPie[key] = allSum[key];
            sum += allSum[key];
          }
        }
      }
      for (let key in dataForPie) {
        if (dataForPie.hasOwnProperty(key)) {
          // eslint-disable-next-line
          dataForPie[key] = parseFloat((dataForPie[key] / sum).toFixed(2));
        }
      }

      let smallest = 0;
      const percentBase = 100;
      let smallestKey = Object.keys(dataForPie)[0];
      for (let key in dataForPie) {
        if (dataForPie.hasOwnProperty(key)) {
          smallest =
            dataForPie[key] * percentBase <= smallest
              ? dataForPie[key]
              : smallest;
          smallestKey =
            dataForPie[key] * percentBase <= smallest ? key : smallestKey;
        }
      }
      let othersum = 0;
      for (let key in dataForPie) {
        if (dataForPie.hasOwnProperty(key)) {
          if (key !== smallestKey) {
            othersum += dataForPie[key];
          }
        }
      }
      let remaining = 1 - othersum;
      dataForPie[smallestKey] = remaining;

      return dataForPie;
    },
    initPie(pieItems) {
      let keys = Object.keys(pieItems);
      let colorsArr = [
        colors.chartPrimary,
        colors.chartSecondary,
        colors.chartTertiary
      ];
      let pieColors = {};
      for (let index = 0; index < keys.length; index++) {
        if (pieItems[keys[index]] !== 0) {
          const element = keys[index];
          pieColors[element] = colorsArr[index];
        }
      }

      let newObj = {};
      for (let key in pieItems) {
        if (pieItems.hasOwnProperty(key) && pieItems[key] !== 0) {
          newObj[key] = pieItems[key];
        }
      }

      this.$nextTick(() => {
        let canvas = document.getElementById('pieCanvas-' + this.widgetInfo.id);
        diagJS.PieChart(newObj, pieColors, canvas, false).draw();
      });
    }
  },
  mounted() {
    this.months = this.monthNames.map(monthName =>
      monthName.substring(0, this.monthLength)
    );
    EventBus.$on('reRenderChart', () => {
      this.chartKey++;
    });
    if (!this.widgetInfo) {
      this.chartReady = true;
      return;
    }
    this.dateRangeFrom = null;
    this.dateRangeTo = null;
    this.chartType = this.chartTypeMap[this.widgetInfo.widgetGraphName];
    this.setSelectedForEdit(null);
    const allWidgetData = this.getWidgetData();
    if (
      allWidgetData[this.widgetInfo.id] !== undefined &&
      this.getCurrentOrgFetchedData().date === this.selectedDate
    ) {
      this.processResponse(allWidgetData[this.widgetInfo.id]);
    } else {
      this.getCardData();
    }
  }
};
</script>

<style scoped>
.tertiaryColor {
  background-color: #7440fb;
  border: 1px solid #7440fb;
}

/* .widget-heading-outer {
  z-index: 2;
} */
.canvas {
  z-index: 1;
}
.loader-row {
  margin-top: 10px;
}

.loader-row > div {
  text-align: center;
}

.no-data {
  color: #58e2c2;
  font-size: 24px;
  margin-top: 90px;
}

.chart-container {
  /* overflow: scroll; */
}
</style>

<style>
/* .editWidgetBtn {
  z-index: 1;
} */
.canvas-parent {
  position: relative;
}
.canvas {
  position: absolute;
  background: transparent;
  top: -90px;
  left: 50%;
  margin-left: -200px;
}
.settingImageStyle .v-image__image {
  background-size: 95%;
}
.v-text-field input {
  padding: 0;
}

.v-icon {
  font-size: 21px;
}

.v-input__control .v-input__slot {
  min-height: auto;
  margin-bottom: 0;
}

.v-messages.theme--light {
  min-height: 0;
}

[role='combobox'].v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 12px;
}
.google-visualization-tooltip {
  /* white-space: nowrap; */
  position: relative;
  background-color: #58e2c2 !important;
  border-radius: 2px !important;
  box-shadow: none !important;
  border: none !important;
  /* max-width: 55px !important; */
}

.google-visualization-tooltip span {
  color: #fff !important;
}

.google-visualization-tooltip:after {
  top: 20px;
  left: 45%;
  content: url('./../../../assets/images/pointer.svg');
  height: 15;
  width: 15;
  position: absolute;
  pointer-events: none;
  margin-left: 0px;
}
.google-visualization-tooltip.blue {
  background-color: #1b2342 !important;
}
.google-visualization-tooltip.blue:after {
  content: url('./../../../assets/images/pointerBlue.svg');
}
.google-visualization-tooltip.purple {
  background-color: #7440fb !important;
}
.google-visualization-tooltip.purple:after {
  content: url('./../../../assets/images/pointerPurple.svg');
}

.google-visualization-tooltip-item-list {
  padding: 0 !important;
}
.google-visualization-tooltip-item-list,
.google-visualization-tooltip-item {
  margin: 0 !important;
}
.google-visualization-tooltip-item {
  padding: 5px 15px !important;
}
.google-visualization-tooltip.darkTooltip {
  background-color: #1b2342 !important;
}
.google-visualization-tooltip.darkTooltip:after {
  border-top-color: #1b2342;
}
</style>
